module.exports = __webpack_public_path__ + "static/media/uparrow.e35e752c.svg";